import React from 'react';
import PropTypes from 'prop-types';

export default function CommonModel({ open, onClose, onAction, text }) {

    const handleClose = () => {
        onClose();
    };

    const handleAction = () => {
        onAction();
    };

    return (
        <>
            {open && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div className="bg-white rounded-lg shadow-lg w-96">
                        <div className="p-4 border-b">
                            <h2 id="alert-dialog-title" className="text-lg font-semibold">
                                {text}
                            </h2>
                        </div>
                        <div className="flex justify-end p-4 space-x-2">
                            <button
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                                onClick={handleClose}
                                autoFocus
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 text-sm font-medium text-red-600 bg-red-100 rounded hover:bg-red-200"
                                onClick={handleAction}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>

    );
}

CommonModel.propTypes = {
    open: PropTypes.isRequired,
    onClose: PropTypes.isRequired,
    onAction: PropTypes.func.isRequired,
    text: PropTypes.isRequired
};
